import script from "./BaseRibbon.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseRibbon.vue?vue&type=script&setup=true&lang=js"

import "./BaseRibbon.vue?vue&type=style&index=0&id=12c22b45&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12c22b45"]])

export default __exports__